(function() {
  'use strict';

  function initStyledSetProduct() {
    // ==========================================================================
    // 1. THUMBNAIL SWITCHING
    // ==========================================================================
    const thumbButtons = document.querySelectorAll('.ss-thumbs-row .ss-thumb');
    const mainImg = document.querySelector('.ss-stage-img');

    if (thumbButtons.length > 0 && mainImg) {
      thumbButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          thumbButtons.forEach(btn => btn.classList.remove('ss-thumb-active'));
          this.classList.add('ss-thumb-active');
          const newUrl = this.getAttribute('data-img-url');
          if (newUrl) mainImg.src = newUrl;
        });
      });
    }

    // ==========================================================================
    // 2. DUAL SELECTOR — SET (swatches) + SIZE (buttons) → VARIANT MATCHING
    //    Option 0 = Set, Option 1 = Size
    // ==========================================================================
    const sizePicker = document.querySelector('[data-size-picker]');
    const setPicker = document.querySelector('[data-set-picker]');
    const variantDataEl = document.querySelector('[data-variant-data]');
    const variantIdInput = document.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-price]');
    const comparePriceEl = document.querySelector('[data-compare-price]');
    const saveBadgeEl = document.querySelector('[data-save-badge]');
    const addBtn = document.querySelector('[data-add-to-cart]');
    const selectedSetNameEl = document.querySelector('[data-selected-set-name]');
    const stickyVariantTitle = document.querySelector('.ss-sticky-variant-title');
    const stickyPrice = document.querySelector('.ss-sticky-price');

    // Parse variant data
    let variants = [];
    if (variantDataEl) {
      try {
        variants = JSON.parse(variantDataEl.textContent);
      } catch(e) {
        console.error('Styled Set: Failed to parse variant data', e);
      }
    }

    // State
    let selectedSet = null;
    let selectedSize = null;

    // Initialize from active buttons
    if (setPicker) {
      const activeSet = setPicker.querySelector('.ss-set-swatch--active');
      if (activeSet) selectedSet = activeSet.getAttribute('data-set-value');
    }
    if (sizePicker) {
      const activeSize = sizePicker.querySelector('.ss-size-btn--active');
      if (activeSize) selectedSize = activeSize.getAttribute('data-size-value');
    }

    function findVariant(set, size) {
      if (!set || !size) return null;
      for (const v of variants) {
        const vSet = v.options[0] ? String(v.options[0]) : '';
        const vSize = v.options[1] ? String(v.options[1]) : '';
        if (vSet === set && vSize === size) {
          return v;
        }
      }
      return null;
    }

    function findFirstImageForSet(set) {
      if (!set) return null;
      for (const v of variants) {
        const vSet = v.options[0] ? String(v.options[0]) : '';
        if (vSet === set && v.image) {
          return v.image;
        }
      }
      return null;
    }

    function swapMainImage(url) {
      if (!url || !mainImg) return;
      mainImg.src = url;
      // Update thumbnail active state
      if (thumbButtons.length > 0) {
        thumbButtons.forEach(btn => btn.classList.remove('ss-thumb-active'));
        thumbButtons.forEach(btn => {
          const btnUrl = btn.getAttribute('data-img-url');
          if (btnUrl && url && (btnUrl.includes(url.split('/').pop().split('?')[0]) || url.includes(btnUrl.split('/').pop().split('?')[0]))) {
            btn.classList.add('ss-thumb-active');
          }
        });
      }
    }

    function updateUI() {
      const variant = findVariant(selectedSet, selectedSize);

      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.innerHTML = 'Select options';
        }
        return;
      }

      // Update hidden variant ID
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update price
      if (priceEl) priceEl.textContent = variant.price;

      // Update compare price and save badge
      if (variant.compare_at_price && variant.compare_at_price !== 'null') {
        if (comparePriceEl) {
          comparePriceEl.textContent = variant.compare_at_price;
          comparePriceEl.style.display = '';
        }
        if (saveBadgeEl) {
          const priceNum = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
          const compareNum = parseFloat(variant.compare_at_price.replace(/[^0-9.]/g, ''));
          if (priceNum && compareNum && compareNum > priceNum) {
            const currency = variant.price.replace(/[\d.,]/g, '').trim();
            const savings = (compareNum - priceNum).toFixed(2);
            saveBadgeEl.textContent = 'Save ' + currency + savings;
            saveBadgeEl.style.display = '';
          }
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (saveBadgeEl) saveBadgeEl.style.display = 'none';
      }

      // Update add-to-cart button
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.innerHTML = 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.innerHTML = 'Sold Out';
        }
      }

      // Swap main gallery image to the variant image (based on Set)
      if (variant.image) {
        swapMainImage(variant.image);
      }

      // Update sticky bar
      if (stickyVariantTitle) {
        const setPart = selectedSet || '';
        const sizePart = selectedSize || '';
        stickyVariantTitle.textContent = [setPart, sizePart].filter(Boolean).join(' · ');
      }
      if (stickyPrice && variant.price) {
        stickyPrice.textContent = variant.price;
      }

      // Update swatch availability — grey out sets that don't have a matching available variant for the current size
      if (setPicker && selectedSize) {
        setPicker.querySelectorAll('.ss-set-swatch').forEach(swatch => {
          const setVal = swatch.getAttribute('data-set-value');
          const match = findVariant(setVal, selectedSize);
          if (match && match.available) {
            swatch.classList.remove('ss-set-swatch--unavailable');
          } else {
            swatch.classList.add('ss-set-swatch--unavailable');
          }
        });
      }

      // Update size availability — grey out sizes that don't have a matching available variant for the current set
      if (sizePicker && selectedSet) {
        sizePicker.querySelectorAll('.ss-size-btn').forEach(btn => {
          const sizeVal = btn.getAttribute('data-size-value');
          const match = findVariant(selectedSet, sizeVal);
          if (match && match.available) {
            btn.classList.remove('ss-size-btn--unavailable');
          } else {
            btn.classList.add('ss-size-btn--unavailable');
          }
        });
      }
    }

    // Set picker click handler
    if (setPicker) {
      setPicker.addEventListener('click', function(e) {
        const swatch = e.target.closest('.ss-set-swatch');
        if (!swatch) return;
        e.preventDefault();

        setPicker.querySelectorAll('.ss-set-swatch').forEach(s => s.classList.remove('ss-set-swatch--active'));
        swatch.classList.add('ss-set-swatch--active');
        selectedSet = swatch.getAttribute('data-set-value');

        // Update the selected name display
        if (selectedSetNameEl) selectedSetNameEl.textContent = selectedSet;

        // Swap main image immediately
        const swatchImgUrl = swatch.getAttribute('data-swatch-image');
        if (swatchImgUrl) {
          swapMainImage(swatchImgUrl);
        } else {
          const variantImg = findFirstImageForSet(selectedSet);
          if (variantImg) swapMainImage(variantImg);
        }

        updateUI();
      });
    }

    // Size picker click handler
    if (sizePicker) {
      sizePicker.addEventListener('click', function(e) {
        const btn = e.target.closest('.ss-size-btn');
        if (!btn) return;
        e.preventDefault();

        sizePicker.querySelectorAll('.ss-size-btn').forEach(b => b.classList.remove('ss-size-btn--active'));
        btn.classList.add('ss-size-btn--active');
        selectedSize = btn.getAttribute('data-size-value');
        updateUI();
      });
    }

    // Initial sync
    updateUI();

    // ==========================================================================
    // 3. STICKY BAR SHOW/HIDE
    // ==========================================================================
    const stickyBar = document.getElementById('ss-sticky-bar') || document.querySelector('.ss-sticky-bar');
    if (stickyBar) {
      const thresholdAttr = stickyBar.getAttribute('data-threshold');
      const threshold = thresholdAttr ? parseInt(thresholdAttr, 10) : 700;

      let ticking = false;
      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            if (window.scrollY > threshold) {
              stickyBar.classList.add('ss-sticky-visible');
            } else {
              stickyBar.classList.remove('ss-sticky-visible');
            }
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    }

    // ==========================================================================
    // 4. ADD TO CART (AJAX)
    // ==========================================================================
    const cartForms = document.querySelectorAll('.ss-buy-form, .ss-sticky-form, .ss-final-cta-form');

    cartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        let vIdInput = form.querySelector('input[name="id"]');
        let variantId = vIdInput ? vIdInput.value : null;

        if (!variantId) {
          const heroInput = document.querySelector('.ss-buy-form [data-variant-id]');
          if (heroInput) variantId = heroInput.value;
        }

        if (!variantId) return;

        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn ? submitBtn.innerHTML : 'Add to Cart';

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Adding...';
        }

        const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(data => {
              throw new Error(data.description || data.message || 'Could not add product to cart');
            });
          }
          return response.json();
        })
        .then(data => {
          if (submitBtn) submitBtn.innerHTML = 'Added! Redirecting...';
          setTimeout(() => {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
          }, 400);
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
          alert(error.message || 'There was an error adding this item to your cart.');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStyledSetProduct);
  } else {
    initStyledSetProduct();
  }
})();
